<template>
  <a-modal
      title="选择采购品目"
      :visible="visible"
      @ok="handleOk"
      :maskClosable="false"
      @cancel="handleCancel"
      :confirm-loading="confirmLoading"
      :width="1300"
  >
    <div>
      <div>
        <span>
          品目编码：
            <a-input placeholder="请输入需要查询的品目编码" v-model="queryParam.fspmbm" style="width:200px"></a-input>
        </span>
        <span>
          品目名称：
          <a-input placeholder="请输入需要查询的品目名称" v-model="queryParam.fspmmc" style="width:200px"></a-input>
        </span>
        <a-button type="primary" class="ml-5" icon="search" @click="onSearch">查询</a-button>
        <a-button type="Default" class="ml-5" @click="clearMethod">清空</a-button>

      </div>
      <div class="mt-4">
        已选择品目：
        <a-button-group size="small" class="ml-2 mt-2" v-for="(item) in userSelectContent">
          <a-button>{{ item.fspmmc }}</a-button>
          <a-button @click="removeMethod(item)" type="danger">
            <a-icon type="delete"></a-icon>
          </a-button>
        </a-button-group>
      </div>
      <s-table
          class="mt-4"
          ref="table"
          :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange,
                getCheckboxProps: record =>({ props: { disabled: disableArr.includes(record.fspmbm) || (record.fspmbm.indexOf(disableArr[3]) !== -1 && record.nextLevelNumber>0) } })}"
          :columns="columns"
          :pagination="taskPagination"
          :pageSize="pageSize"
          :data="loadData"
          :rowKey="record => record.fid"
      >
      </s-table>
    </div>
  </a-modal>

</template>

<script>
import { PageView } from '@/layouts'
import STable from '@/components/Table'
import { QueryPurchaseItems } from '@/epp/expertmain/purchaseitems/PurchaseRequest'
const disableArr = ['A', 'B', 'C', '000000']
export default {
  name: 'ChoosePurchaseItem',
  components: {
    PageView,
    STable
  },
  mounted () {
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    pageSize: {
      type: Number,
      default: 8
    },
    pageSizeOptions: {
      type: Array,
      default () {
        return ['8', '16', '24', '32', '40']
      }
    }
  },
  data () {
    return {
      disableArr,
      taskPagination: {
        showTotal: total => `共 ${total} 条`,
        size: 'small',
        pageSizeOptions: this.pageSizeOptions
      },
      userSelectContent: [],//用户勾选的内容
      selectedRowKeys: [],
      columns: [
        {
          title: '品目编码',
          dataIndex: 'fspmbm'
        },
        {
          title: '品目名称',
          dataIndex: 'fspmmc'
        },
        {
          title: '描述',
          dataIndex: 'fsdesc'
        },

      ],
      queryParam: {
        fspmbm: '',
        fspmmc: '',
      },
      copyData: [],
      loadData: async parameter => {
        const params = { ...parameter, ...this.queryParam }
        return QueryPurchaseItems(params)
      },
      confirmLoading: false
    }
  },
  created () {
  },
  methods: {
    //数据回显
    preView (json) {
      let that = this
      this.$nextTick(() => {
        that.selectedRowKeys = []
        json.forEach(item => {
          that.selectedRowKeys.push(item.fid)
        })
        that.userSelectContent = json
        this.copyData = that.copyData.concat(json)
      })
    },
    //确认后数据传回调用方
    handleOk () {
      this.$emit('success', this.userSelectContent)
    },
    //关闭窗口
    handleCancel () {
      this.$emit('cancel')
    },
    //清空的方法
    clearMethod () {
      this.queryParam = {
        fspmbm: '',
        fspmmc: '',
      }
      this.onSearch()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.userSelectContent = []
      this.copyData = this.copyData.concat(selectedRows)
      selectedRowKeys.forEach(item => {
        const data = this.copyData.filter(it => it.fid === item)[0]
        this.userSelectContent.push(data)
      })
    },
    onSearch () {
      this.$refs.table.refresh(true)
    },
    removeMethod (data) {
      this.userSelectContent = this.userSelectContent.filter(item => item.fid !== data.fid)
      this.selectedRowKeys = this.selectedRowKeys.filter(item => item !== data.fid)
    }
  }
}
</script>

<style lang="less" scoped>
.card {
  margin-bottom: 24px;
}

.close-span:hover {
  cursor: pointer;
}
</style>
